export class StringUtils {
    static capitalize(str: string | null) {
        if (!str) return '';
        let lowercase = str.toLowerCase();
        return lowercase[0].toUpperCase() + lowercase.substr(1);
    }

    static snakeCaseToRegular(string: string, capFirstLetter = false, capAllWords = false) {
        if (capFirstLetter) string = string.charAt(0).toUpperCase() + string.substr(1);
        string = string.split('_').map(word => {
            if (capAllWords) return StringUtils.capitalize(word);
            else return word;
        }).join(' ');
        return string;
    }

    static camelCaseToRegular(text:string) {
        const result = text.replace(/([A-Z])/g, " $1");
        return result.charAt(0).toUpperCase() + result.slice(1);
    }

    static toPascalWithSeparator(string, separator: string, capAllWords) {
        string = string.split(separator).map(word => {
            if (capAllWords) return StringUtils.capitalize(word);
            else return word;
        }).join(' ');
        return string;
    }

    static insert(str: string, index: number, insert: string,) {
        if (index > 0) {
            return str.substring(0, index) + insert + str.substring(index, str.length);
        } else return str;
    }

    static addMultipleToNoun(num: number, noun: string, modifier = 's') {
        if (num === 1) return noun;
        else return noun + modifier;
    }

    static stringifyAndRemoveCircular(values) {
        if (values) {
            let cache = [];
            let newValues = JSON.stringify(values, (key, value) => {
                if (typeof value === 'object' && value !== null) {
                    // Duplicate reference found, discard key
                    if (cache.includes(value)) return;

                    // Store value in our collection
                    cache.push(value);
                }
                return value;
            })
            cache = null;
            return newValues;
        } else {
            return values;
        }
    }
}